import { VStack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { LoginForm } from "../../components/login_page/LoginForm";
import { MetaTag } from "../../utils/MetaTag";

export const Login = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const loginType = queryParams.get("type") || "";

  const reseller = () => (
    <LoginForm
      title="Login Akun Reseller"
      subTitle="Mau bisnis tanpa modal besar? Jadi reseller di BisnisLink.id! Pilih produk, jual dengan bebas, dan nikmati komisi menguntungkan dari setiap transaksi."
      url="/v1/auth/reseller/login"
      userType={1}
    />
  );

  const buyer = () => (
    <LoginForm
      title="Login Akun Buyer"
      subTitle="Belanja mudah dan aman langsung dari para UMKM terbaik! Temukan berbagai produk berkualitas dengan harga terbaik dan dukungan Reseller terpercaya."
      url="/v1/auth/buyer/login"
      userType={0}
    />
  );

  const supplier = () => (
    <LoginForm
      title="Login Akun Supplier"
      subTitle="Tingkatkan penjualan produkmu tanpa repot! Gabung sebagai supplier di BisnisLink.id dan biarkan jaringan reseller memasarkan produkmu ke lebih banyak pelanggan."
      url="/v1/auth/supplier/login"
      userType={2}
    />
  );

  return (
    <VStack p={10} justify={"center"}>
      <MetaTag
        title={`Login Akun ${loginType || "Pembeli"} | BisnisLink`}
        description={`Login akun ${loginType || "Pembeli"} di BisnisLink.id. Belanja mudah dan aman langsung dari para UMKM terbaik! Temukan berbagai produk berkualitas dengan harga terbaik dan dukungan Reseller terpercaya.`}
      />

      {loginType === "reseller"
        ? reseller()
        : loginType === "supplier"
        ? supplier()
        : buyer()}
    </VStack>
  );
};
